import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { PipesModule } from '../../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-empty-state',
	standalone: true,
	imports: [CommonModule, PipesModule, TranslateModule],
	templateUrl: './empty-state.component.html',
	styleUrl: './empty-state.component.scss'
})
export class EmptyStateComponent {

	@Input() image: string = '';
	@Input() title: string = '';
	@Input() text: string = '';
	@Input() dynamicText: string = '';

}
